import { CardItem, LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'
import { Stack } from '@mui/material'

export default function AssetDeviationAnalysisLoading() {
    return (
        <PageGridContainer>
            <PageGridItem columnSpan={4} columnSpanXs={4}>
                <CardItem>
                    <Stack direction="row" gap={tokens.SizingSpacing300}>
                        <Stack direction="column" gap={tokens.SizingSpacing300} flex={1}>
                            {Array.from({ length: 20 }, (_, i) => (
                                <LoadingSkeleton key={i} height={'18px'} sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }} />
                            ))}
                        </Stack>
                        {Array.from({ length: 3 }, (_, i) => (
                            <LoadingSkeleton key={i} sx={{ transform: 'none', borderRadius: tokens.SizingCornerS, flex: 1 }} />
                        ))}
                    </Stack>
                </CardItem>
            </PageGridItem>
            <PageGridItem columnSpan={2} columnSpanXs={4}>
                <Stack direction={'column'} gap={tokens.SizingSpacing300}>
                    <CardItem>
                        <Stack direction="column" gap={tokens.SizingSpacing150}>
                            <LoadingSkeleton
                                width={'24px'}
                                height={'24px'}
                                sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }}
                            />
                            <Stack gap={tokens.SizingSpacing075}>
                                <LoadingSkeleton
                                    width={'120px'}
                                    height={'18px'}
                                    sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }}
                                />
                                <LoadingSkeleton
                                    width={'240px'}
                                    height={'18px'}
                                    sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }}
                                />
                            </Stack>
                            <Stack gap={tokens.SizingSpacing075}>
                                <LoadingSkeleton height={'18px'} sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }} />
                                <LoadingSkeleton height={'18px'} sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }} />
                                <LoadingSkeleton height={'18px'} sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }} />
                                <LoadingSkeleton height={'18px'} sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }} />
                                <LoadingSkeleton height={'18px'} sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }} />
                            </Stack>
                        </Stack>
                    </CardItem>
                    <CardItem>
                        <Stack direction="column" gap={tokens.SizingSpacing150}>
                            <LoadingSkeleton
                                width={'24px'}
                                height={'24px'}
                                sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }}
                            />
                            <Stack gap={tokens.SizingSpacing075}>
                                <LoadingSkeleton
                                    width={'120px'}
                                    height={'18px'}
                                    sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }}
                                />
                                <LoadingSkeleton
                                    width={'240px'}
                                    height={'18px'}
                                    sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }}
                                />
                            </Stack>
                            <Stack gap={tokens.SizingSpacing075}>
                                <LoadingSkeleton height={'18px'} sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }} />
                                <LoadingSkeleton height={'18px'} sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }} />
                                <LoadingSkeleton height={'18px'} sx={{ transform: 'none', borderRadius: tokens.SizingCornerS }} />
                            </Stack>
                        </Stack>
                    </CardItem>
                </Stack>
            </PageGridItem>
        </PageGridContainer>
    )
}
